var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 131.93 139.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#383c3f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Log_Out") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M89.77,109.79a5.9,5.9,0,0,0,3.92-1.87c6.5-6.27,13.15-12.59,19.58-18.7l16-15.24a15.39,15.39,0,0,0,2-2.62l.66-1V69.05l-.48-.71a12.87,12.87,0,0,0-1.58-2.07c-10.08-9.63-20.36-19.39-30.3-28.83l-6-5.65a13.3,13.3,0,0,0-1.21-1.06,4.19,4.19,0,0,0-3.91-.59A4,4,0,0,0,85.88,33c-.36,1.56.13,2.8,1.72,4.31q10.17,9.61,20.31,19.27l4.72,4.49c.27.26.53.53.86.87l3.83,3.93H39.62a4,4,0,0,0-2.88,1.56A3.67,3.67,0,0,0,36,70.55c.18.8.72,3.23,4.87,3.23h76.22c-1.48,1.61-3,3.23-4.45,4.84-2.88,2.72-5.74,5.45-8.61,8.19-5.29,5-10.75,10.24-16.2,15.29a5.4,5.4,0,0,0-2,3.76A4,4,0,0,0,87,108.58,4.39,4.39,0,0,0,89.77,109.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.08,124.44C.28,132.6,7,139.57,14.7,139.67c13.08.15,26.39.12,39.27.1H70.22a4,4,0,0,0,3.7-4.28,4.2,4.2,0,0,0-.13-.79c-.36-1.23-1.24-2.86-4.71-2.86h-52c-5.82,0-9-3.19-9-9v-106a11.3,11.3,0,0,1,.36-3.18C9.44,10,12.52,7.9,17,7.9h53.4a4,4,0,0,0,2.9-6.15A4.54,4.54,0,0,0,69.49,0H16.3a15.65,15.65,0,0,0-3.86.42A15.82,15.82,0,0,0,.08,16.23v95.23C0,115.73,0,120.13.08,124.44Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/Log_Out.1280d758d13a99fc6c6827fe6b4c00ae.svg";
export { ForwardRef as ReactComponent };